import React from 'react'
import ImageAttribution from 'components/ImageAttribution'
import ImageTrackingPixel from 'components/ImageTrackingPixel'

const Gallery = ({ story }) => {
  const {
    post_type_meta: { gallery }
  } = story
  if (!gallery) return null
  return (
    gallery &&
    gallery.images.map((item, idx) => {
      return (
        <div className='hq-image' key={idx}>
          <img src={`${gallery.base}${item.image}`} alt='' />
          <ImageTrackingPixel url={item?.attribution?.view_tracking_url ?? null} />
          {item.attribution && <ImageAttribution attribution={item.attribution} />}
        </div>
      )
    })
  )
}

export default Gallery
